<template>
  <div class="list-group">
    <div class="list-group-item">
      <h1>{{ $t("profile.profile") | capitalize }}</h1>
      <PasswordReset
        v-if="showPasswordReset"
        @close="togglePasswordReset()"
      ></PasswordReset>
      <form ref="profile" @submit.prevent>
        <div class="list-group">
          <div class="list-group-item">
            <name-field
              :value="profileForm.name"
              @input="
                newName => {
                  profileForm.name = newName;
                }
              "
            ></name-field>
          </div>
          <!--<div class="list-group-item">
          <h3>{{ $t("profile.languages") | capitalize }}</h3>
          <languages
            :value="profileForm.languages"
            :multiple="true"
            @input="
              newLanguages => {
                profileForm.languages = newLanguages;
              }
            "
          ></languages>
        </div>-->
          <div class="list-group-item">
            <h3>{{ $t("address.address", [""]) | title }}</h3>
            <mailing-address
              :value="profileForm.address"
              @input="
                newAddress => {
                  profileForm.address = newAddress;
                }
              "
            />
          </div>
        </div>
        <button @click="saveProfile()" class="btn btn-primary btn-block">
          {{ $t("message.save") | capitalize }}
        </button>
      </form>
    </div>
  </div>
</template>
<script>
import PasswordReset from "@/components/PasswordReset";
import NameField from "@/components/NameField";
import MailingAddress from "@/components/Address";
//for future
//import Languages from "@/components/Languages";
import { mapState } from "vuex";
export default {
  components: {
    PasswordReset,
    NameField,
    MailingAddress
    //Languages
  },
  computed: {
    ...mapState(["userProfile"])
  },
  watch: {
    userProfile(p) {
      if (p !== undefined) {
        console.log(p);
        this.loadData();
      }
    },
    "profileForm.languages": function(n, o) {
      console.log("langs", n, o);
    }
  },
  mounted() {
    if (this.userProfile) {
      this.loadData();
    }
  },
  methods: {
    loadData() {
      if (this.userProfile.details) {
        this.profileForm.name = this.userProfile.details.name;
      }
      if (this.userProfile.details && this.userProfile.details.address) {
        this.profileForm.address.address_1 = this.userProfile.details.address.address_1;
        this.profileForm.address.address_2 = this.userProfile.details.address.address_2;
        this.profileForm.address.city = this.userProfile.details.address.city;
        this.profileForm.address.country = this.userProfile.details.address.country;
        this.profileForm.address.state = this.userProfile.details.address.state;
        this.profileForm.address.zip = this.userProfile.details.address.zip;
      }
      if (this.userProfile.details && this.userProfile.details.languages) {
        this.profileForm.languages = this.userProfile.details.languages;
      }
    },
    saveProfile() {
      const self = this;
      this.$store
        .dispatch("updateProfile", {
          name: this.profileForm.name,
          address: this.profileForm.address,
          languages: this.profileForm.languages
        })
        .then(() => {
          let message = self.$t("profile.success");
          self.flashMessage.show({
            status: "success",
            message: self.$options.filters.capitalize(message)
          });
        })
        .catch(function(err) {
          console.log(err);
          let message = self.$t("profile.error");
          self.flashMessage.show({
            status: "error",
            message: self.$options.filters.capitalize(message)
          });
        });
    }
  },
  data() {
    return {
      profileForm: {
        name: "",
        languages: [],
        address: {
          address_1: "",
          address_2: "",
          country: "",
          state: "",
          zip: ""
        }
      },
      showPasswordReset: true
    };
  }
};
</script>
